import React, { useEffect, useRef, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { createEmission, deleteEmission, fetchEmissions, updateEmission } from '../../api/emission';
import IsEmpty from '../../components/IsEmpty';
import MediaSelector from '../../components/MediaSelector';
import { toast } from 'react-toastify';
import Modal from 'react-responsive-modal';
import ProgramCard from '../../components/ProgramCard';
import ResponsivePaginationComponent from 'react-responsive-pagination';

const Emissions = () => {

    const {register} = useForm();

    const [showInput, setShowInput] = useState(false)

    const [picture, setPicture] = useState("")
    const [name, setName] = useState("")
    const [startAt, setStartAt] = useState()
    const [endAt, setEndAt] = useState()
    const [selectedEmission, setSelectedEmission] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [openDelModal, setOpenDelModal] = useState(false)
    const [openViewModal, setOpenViewModal] = useState(false)
    const [openUpdateModal, setOpenUpdateModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);




    // Fetch All Emissions
    const { data: emissionsList, status: listStatus } = useQuery({
        queryKey: ["emission",  {page: currentPage}],
        queryFn: () => fetchEmissions({'order[id]':"asc", page: currentPage}),
        retry: 1,
        refetchOnReconnect: true,
    });








    const queryClient = useQueryClient();

    const clear = () => {
        setName('')
        setPicture('')
        setStartAt()
        setEndAt()
    }

    // Create emission
    const toastCreate = useRef(null);
    const addEmission = useMutation({
        mutationFn: (data)=> createEmission(data),
        onMutate: ()=>{
            toastCreate.current = toast.loading("Création en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: () => {
            toast.dismiss(toastCreate.current)
            toastCreate.current = toast.success("Emission ajoutée avec succès", {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            queryClient.invalidateQueries(['emission']);
            clear()
            setShowInput(false)
        },
        onError: (err) =>{
            toast.dismiss(toastCreate.current)
            toastCreate.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
        }
    });

    const submit = () => {
        if (!name || !picture || !startAt || !endAt) {
            alert("Renseigner tout les champs")
            return
        }
        const formattedStartAt = startAt + ":00";
        const formattedEndAt = endAt + ":00";
        addEmission.mutate({name:name, picture:picture, startAt:formattedStartAt, endAt:formattedEndAt})
    }




    // Mutation pour gérer la suppression
    const toastDel = useRef(null);
    const deleteMutation = useMutation({
        mutationFn: deleteEmission,
        onMutate: ()=>{
            toastDel.current = toast.loading("Suppression en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: () => {
            toast.dismiss(toastDel.current)
            toastDel.current = toast.success("Emission supprimée avec succès", {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            setSelectedEmission()
            queryClient.invalidateQueries({ queryKey: ["emission"] });
            setOpenDelModal(false);
        },
        onError: (err) => {
            toast.dismiss(toastDel.current)
            toastDel.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
            console.log("Erreur lors de la suppression :", err);
        },
    });

    // Confirmer la suppression
    const handleConfirmDelete = (emissionId) => {
        deleteMutation.mutate(emissionId);
    };







    // Update emission
    const toastUpdate = useRef(null);
    const updateMutation = useMutation({
        mutationFn: (data)=> updateEmission(data.id, data.formData),
        onMutate: ()=>{
            toastUpdate.current = toast.loading("Modification en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: () => {
            toast.dismiss(toastUpdate.current)
            toastUpdate.current = toast.success("Emission modifiée avec succès", {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            queryClient.invalidateQueries({ queryKey: ["emission"] });
            setSelectedEmission()
            setOpenUpdateModal(false)
            clear()
        },
        onError: (err) =>{
            toast.dismiss(toastUpdate.current)
            toastUpdate.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true
            });
        }
    });

    const modify = () => {
        if (!name || !picture || !startAt || !endAt) {
            alert("Renseigner tout les champs")
            return
        }
        const formattedStartAt = startAt + ":00";
        const formattedEndAt = endAt + ":00";
        updateMutation.mutate({id:selectedEmission?.id, formData:{name:name, picture:picture, startAt:formattedStartAt, endAt:formattedEndAt}})
    }


    // 5. Pagination setup
    const itemsPerPage = 8;
    const totalPages = Math.ceil((emissionsList?.data?.totalItems || 0) / itemsPerPage);
    const [emissions, setEmissions] = useState();

    useEffect(() => {
        setEmissions(emissionsList?.data?.member);
    }, [emissionsList]);


    function handlePageChange(page) {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'instant' });
    }




    return (
        <div>
            <h1 className='fs-3 fw-bold mb-2'>Emissions</h1>

            <div className='bg-black mt-4 rounded-3 p-2 shadow'>
                <h2 className='fs-5 fw-bold mb-2'>Liste des émissions</h2>

                <div role='button' onClick={()=>setShowInput(true)} className='d-flex align-items-center flex-grow-0 px-2 py-1 bgcolor-primary rounded-3' style={{ width: 'fit-content' }}>
                    <i className="fa-light fa-square-plus me-2 text-white"></i>
                    <span className=' fs-9s text-white'>Ajouter une émission</span>
                </div>


                {/* Form */}
                <form className='mt-3 row justify-content-between align-items-center' style={{display:showInput?"":"none"}}>
                    <div className='col-12'>
                        <div role='button' className='inputFile mb-2' onClick={()=>setOpenModal(true)} >
                            {
                                !picture?
                                <label className='d-flex flex-column justify-content-center align-items-center h-100 p-2'>
                                    <i className="fa-light fa-images fs-3 opacity-75"></i>
                                    <span className='text-center fw-medium'>Cliquer pour choisir des images ( Entre 0 - 1Mo )</span>
                                </label>
                                :
                                <img
                                    src={picture}
                                    alt={name}
                                    className='img-fluid object-fit-contain m-1 border bordercolor-primary'
                                    style={{ height: "5rem", width: "auto" }}
                                />
                            }
                        </div>
                    </div>

                    <div className='col-12'>
                        <div className='inputBox'>
                            <input {...register("title", {required: true })} onChange={(e)=>(setName(e.target.value))} value={name} type='text' className='w-100 fs-9s' required/>
                            <span>Titre</span>
                            <i></i>
                        </div>
                    </div>

                    <div className='col-md-6 col-12'>
                        <div className='inputBox'>
                            <input {...register("startAt", {required: true })} onChange={(e)=>(setStartAt(e.target.value))} value={startAt} type='time' className='w-100 fs-9s' required/>
                            <span>Heure de début</span>
                            <i></i>
                        </div>
                    </div>

                    <div className='col-md-6 col-12'>
                        <div className='inputBox'>
                            <input {...register("endAt", {required: true })} onChange={(e)=>(setEndAt(e.target.value))} value={endAt} type='time' className='w-100 fs-9s' required/>
                            <span>Heure de fin</span>
                            <i></i>
                        </div>
                    </div>

                    <div className=' d-flex align-items-center mt-3'>
                        <button 
                            onClick={()=>setShowInput(false)}
                            className=' d-flex align-items-center px-2 py-1 border bordercolor-primary rounded-2 me-2 submit'
                        >
                            <i className='fa-light fa-cancel fs-9s me-2'></i>
                            <span className='fs-9s'>Annuler</span>
                        </button>
                        <div 
                            role='button'
                            onClick={()=>submit()}
                            className=' d-flex align-items-center px-2 py-1 border bordercolor-primary bgcolor-primary rounded-2 submit'
                            disabled={addEmission.isPending}
                        >
                            <i className='fa-light fa-square-plus fs-9s me-2'></i>
                            <span className='fs-9s'>{addEmission.isPending? "Patientez...": "Ajouter"}</span>
                        </div>
                    </div>
                </form>


                {/* Liste */}
                <div className='mt-4 pt-2 table-responsive'>
                    <table className='table table-dark table-striped table-hover fs-9s align-middle'>
                        <thead>
                            <tr>
                                <th className='fs-9s'>#</th>
                                <th className='fs-9s'>Image</th>
                                <th className='fs-9s'>Titre</th>
                                <th className='fs-9s'>Heure</th>
                                <th className='fs-9s'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {listStatus === "pending" ?
                            [1,2,3,4,5].map((item, index) => (
                                <tr key={index}>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s py-1 placeholder-wave'><div style={{width:"3rem", height:"2rem"}} className='placeholder col-12 bgcolor-primary rounded'></div></td>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                </tr>
                            ))
                            : listStatus === "error" ? 
                                <tr>
                                    <td  colSpan="5" className='w-100'>
                                        <IsEmpty icon={"fa-light fa-circle-exclamation"} message={"Une erreur est survenue"} />
                                    </td>
                                </tr>
                            :emissions?.length <= 0 ?
                                <tr>
                                    <td  colSpan="5" className='w-100'>
                                        <IsEmpty icon={"fa-light fa-list-timeline"} message={"Aucune émission enregistrée"} />
                                    </td>
                                </tr>
                            :emissions?.map((emission, index) =>  {
                                return (
                                    <tr key={emission.id}>
                                        <td className='py-1 fs-9s fw-bold'>{index+1}</td>
                                        <td className='py-1 fs-9s'>
                                            <img 
                                                alt={"*"} 
                                                src={emission?.picture} 
                                                className='object-fit-cover rounded' 
                                                style={{width:"3rem", height: "2rem"}} 
                                            />
                                        </td>
                                        <td className='py-1 '><span className='text-truncate-1 fs-9s'>{emission?.name}</span></td>
                                        <td className='py-1 '><span className='text-truncate-1 fs-9s'>{emission?.startAt?.slice(0,5)}</span></td>
                                        <td className='py-1 fs-9s'>
                                            <div className=' d-flex flex-nowrap'>
                                                <i role='button' onClick={()=>{setSelectedEmission(emission); setOpenViewModal(true)}} title='see' className='fa-light fa-eye fs-9s text-success me-2'></i>
                                                <i 
                                                    role='button' 
                                                    onClick={()=>{
                                                        setSelectedEmission(emission); 
                                                        setName(emission?.name)
                                                        setPicture(emission?.picture)
                                                        setStartAt(emission?.startAt?.slice(0,5))
                                                        setEndAt(emission?.endAt?.slice(0,5))
                                                        setOpenUpdateModal(true)
                                                    }} 
                                                    title='modify' 
                                                    className='fa-light fa-edit fs-9s text-info me-2'>
                                                </i>
                                                <i role='button' onClick={()=>{setSelectedEmission(emission); setOpenDelModal(true)}} title='delete' className='fa-light fa-trash fs-9s text-danger'></i>
                                            </div>
                                        </td>
                                    </tr>
                                )
                                })
                            }
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div className=' d-flex justify-content-end actualities'>
                        <ResponsivePaginationComponent
                        total={totalPages}
                        current={currentPage}
                        onPageChange={page => handlePageChange(page)}
                        />
                    </div>
                </div>

            </div>

            <MediaSelector openModal={openModal} setOpenModal={setOpenModal} setPicture={setPicture} onClick={()=>setOpenModal(false)}/>


            
            {/* Modal de confirmation supression */}
            <Modal open={openDelModal} onClose={()=>deleteMutation.isPending?null:(setOpenDelModal(false), clear())} center focusTrapped={false}>
                <h2 className='fw-bold text-center fs-2 mb-1 text-danger p-2'>Confirmer la suppression</h2>
                <p className='fs-9s mb-0 text-center'>Êtes-vous sûr de vouloir supprimer cette émission ?</p>
                <h3 className='fw-bold text-center fs-4'>{selectedEmission?.name}</h3>
                <button className='border-0 rounded bg-danger text-white px-2 py-1 me-2 fs-9s' onClick={()=>handleConfirmDelete(selectedEmission?.id)} disabled={deleteMutation.isPending}>
                {deleteMutation.isPending ? "Suppression en cours..." : "Confirmer"}
                </button>
                <button className='border border-1 bordercolor-primary rounded bg-transparent text-black fs-9s px-2 py-1' disabled={deleteMutation.isPending} onClick={()=>setOpenDelModal(false)}>Annuler</button>
            </Modal>
            


            {/* Modal de visualisation */}
            <Modal 
                open={openViewModal} 
                onClose={()=>{setOpenViewModal(false); clear()}} 
                center 
                focusTrapped={false} 
                classNames={{modal:"p-0 rounded-0 bg-black", closeButton:"ps-3"}}
                closeIcon={<i className="fa-regular fs-5 fa-xmark text-white"></i>}
            >
                <ProgramCard image={selectedEmission?.picture} title={selectedEmission?.name} date={selectedEmission?.startAt?.slice(0,5)} />
            </Modal>



            {/* Modal de modification */}
            <Modal 
                open={openUpdateModal} 
                onClose={()=>updateMutation.isPending ? null : (setOpenUpdateModal(false),clear())} 
                center 
                focusTrapped={false} 
                classNames={{modal:"p-2 rounded-3 bg-black text-white border overflow-x-hidden", closeButton:"ps-3"}}
                closeIcon={<i className="fa-regular fs-5 fa-xmark text-white"></i>}
            >
                <h2 className='fs-5 fw-bold mb-2'>Modification des émissions</h2>
                <form className='mt-3 row justify-content-between align-items-center'>
                    <div className='col-12'>
                        <div className='inputFile mb-1 d-flex justify-content-center' >
                            {
                                !picture?
                                <label role='button' onClick={()=>setOpenModal(true)} className='d-flex flex-column justify-content-center align-items-center h-100 p-2'>
                                    <i className="fa-light fa-images fs-3 opacity-75"></i>
                                    <span className='text-center fw-medium'>Cliquer pour choisir des images ( Entre 0 - 1Mo )</span>
                                </label>
                                :
                                <img
                                    role='button'
                                    onClick={()=>setOpenModal(true)}
                                    src={picture}
                                    alt={name}
                                    className='img-fluid object-fit-contain border bordercolor-primary'
                                    style={{ height: "6rem", width: "auto" }}
                                />
                            }
                        </div>
                    </div>

                    <div className='col-12'>
                        <div className='inputBox'>
                            <input {...register("titleU", {required: true })} onChange={(e)=>(setName(e.target.value))} value={name} type='text' className='w-100 fs-9s' required/>
                            <span>Titre</span>
                            <i></i>
                        </div>
                    </div>

                    <div className='col-md-6 col-12'>
                        <div className='inputBox'>
                            <input {...register("startAtUpdate", {required: true })} onChange={(e)=>(setStartAt(e.target.value))} value={startAt} type='time' className='w-100 fs-9s' required/>
                            <span>Heure de début</span>
                            <i></i>
                        </div>
                    </div>

                    <div className='col-md-6 col-12'>
                        <div className='inputBox'>
                            <input {...register("endAtUpdate", {required: true })} onChange={(e)=>(setEndAt(e.target.value))} value={endAt} type='time' className='w-100 fs-9s' required/>
                            <span>Heure de fin</span>
                            <i></i>
                        </div>
                    </div>

                    <div className=' d-flex align-items-center mt-3'>
                        <button 
                            onClick={()=>{setOpenUpdateModal(false);selectedEmission()}}
                            className=' d-flex align-items-center px-2 py-1 border bordercolor-primary rounded-2 me-2 submit'
                        >
                            <i className='fa-light fa-cancel fs-9s me-2'></i>
                            <span className='fs-9s'>Annuler</span>
                        </button>
                        <div 
                            role='button'
                            onClick={()=>modify()}
                            className=' d-flex align-items-center px-2 py-1 border bordercolor-primary bgcolor-primary rounded-2 submit'
                            disabled={updateMutation.isPending}
                        >
                            <i className='fa-light fa-edit fs-9s me-2'></i>
                            <span className='fs-9s'>{updateMutation.isPending? "Patientez...": "Modifier"}</span>
                        </div>
                    </div>
                </form>
            </Modal>
        </div>
    )
}

export default Emissions